// extracted by mini-css-extract-plugin
export default {"table":"JqbxxZckIRgLFAUKUP6d","textLeft":"P1oM7GbU5__RlJabAtNw"};